import Home from '../Pages/home/index';
import DonationDisclosure from '../Pages/donation-disclosure/index';
import HappyChina from '../Pages/happy-china/index';
import ProjectDisclosure from '../Pages/project-disclosure/index';
import Volunteer from '../Pages/volunteer/index';
import AnnualReports from '../Pages/annual-reports/index';
import AuditReports from '../Pages/audit-reports/index';
import BoardMembers from '../Pages/board-members/index';
import Constitution from '../Pages/constitution/index';
import FoundationIntro from '../Pages/foundation-intro/index';
import HearLove from '../Pages/hear-love/index';
import Honors from '../Pages/honors/index';
import IndustryNews from '../Pages/industry-news/index';
import InstitutionalNews from '../Pages/institutional-news/index';
import IntegrityConstruction from '../Pages/integrity-construction/index';
import CleanPeopleHeart from '../Pages/clean-people-heart/index';
import PartyActivities from '../Pages/party-activities/index';
import Regulations from '../Pages/regulations/index';
import SpringAction from '../Pages/spring-action/index';
import Contact from '../Pages/contact/index';
import Article from '../Pages/article/index';
import DonationTaxQualification from '../Pages/donation-tax-qualification/index';
import SocialOrganizationAssessment from '../Pages/social-organization-assessment/index';
import ProjectProgress from '../Pages/project-progress/index';

const routerList = [
    {
        path: '',
        breadcrumbName: '首页',
        component: Home
    },
    {
        path: 'donation-disclosure',
        breadcrumbName: '捐赠公示',
        component: DonationDisclosure
    },
    {
        path: 'happy-china',
        breadcrumbName: '无郁中国行',
        component: HappyChina
    },
    {
        path: 'project-disclosure',
        breadcrumbName: '捐赠公示',
        component: ProjectDisclosure
    },
    {
        path: 'volunteer',
        breadcrumbName: '合作伙伴',
        component: Volunteer
    },
    {
        path: 'annual-reports',
        breadcrumbName: '年度报告',
        component: AnnualReports
    },
    {
        path: 'audit-reports',
        breadcrumbName: '审计报告',
        component: AuditReports
    },
    {
        path: 'board-members',
        breadcrumbName: '理事会成员',
        component: BoardMembers
    },
    {
        path: 'constitution',
        breadcrumbName: '章程',
        component: Constitution
    },
    {
        path: 'foundation-intro',
        breadcrumbName: '基金会简介',
        component: FoundationIntro
    },
    {
        path: 'hear-love',
        breadcrumbName: '爱咪听见',
        component: HearLove
    },
    {
        path: 'honors',
        breadcrumbName: '荣誉认证',
        component: Honors
    },
    {
        path: 'industry-news',
        breadcrumbName: '行业动态',
        component: IndustryNews
    },
    {
        path: 'institutional-news',
        breadcrumbName: '机构动态',
        component: InstitutionalNews
    },
    {
        path: 'integrity-construction',
        breadcrumbName: '清廉建设',
        component: IntegrityConstruction
    },
    {
        path: 'clean-people-heart',
        breadcrumbName: '清廉民心',
        component: CleanPeopleHeart
    },
    {
        path: 'party-activities',
        breadcrumbName: '党建活动',
        component: PartyActivities
    },
    {
        path: 'regulations',
        breadcrumbName: '规章制度',
        component: Regulations
    },
    {
        path: 'spring-action',
        breadcrumbName: '春风行动',
        component: SpringAction
    },
    {
        path: 'contact',
        breadcrumbName: '联系我们',
        component: Contact
    },
    {
        path: 'article/:dataId/:articleId',
        breadcrumbName: '文章详情',
        component: Article
    },
    {
        path: 'donation-tax-qualification',
        breadcrumbName: '公益性捐赠税前扣除资格',
        component: DonationTaxQualification
    },
    {
        path: 'social-organization-assessment',
        breadcrumbName: '社会组织等级评估',
        component: SocialOrganizationAssessment
    },
    {
        path: 'project-progress',
        breadcrumbName: '公益慈善项目开展情况',
        component: ProjectProgress
    }
]

export default routerList;